/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Week_Session_Navigation_PreviousInputs */

const fr_week_session_navigation_previous = /** @type {(inputs: Week_Session_Navigation_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Précédent`)
};

/**

* @param {Week_Session_Navigation_PreviousInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const week_session_navigation_previous = /** @type {((inputs?: Week_Session_Navigation_PreviousInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Week_Session_Navigation_PreviousInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_week_session_navigation_previous(inputs)
});